import { Middleware } from '@reduxjs/toolkit'
import {updateLastActivity, logoutUser} from '../slices/SessionSlice'


const SESSION_TIMEOUT = 30 * 60 * 1000 // 30 minutes

export const sessionMiddleware: Middleware = (store) => (next) => (action) => {
  const state = store.getState()

  const typedAction = action as { type: string }

  // Prevent infinite loop - don't track activity for updateActivity action
  if (state.session.isAuthenticated && typedAction.type !== updateLastActivity.type) {
    store.dispatch(updateLastActivity())

    // Check session expiry
    const now = Date.now()
    if (state.session.sessionExpiry && now > state.session.sessionExpiry) {
      // store.dispatch(logoutUser())
      return
    }
  }

  return next(action)
}
